export const ROOT = 'common/lead';

export const FETCH_LEAD_REQUEST = `${ROOT}/FETCH_LEAD_REQUEST`;
export const FETCH_LEAD_FAILURE = `${ROOT}/FETCH_LEAD_FAILURE`;
export const FETCH_LEAD_SUCCESS = `${ROOT}/FETCH_LEAD_SUCCESS`;

export const CLEAR_LEAD_DATA = `${ROOT}/CLEAR_LEAD_DATA`;